import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import fortilogo from "../Images/home/logo.png";
import drManjinderSandhu from "../Images/home/dr-(col)-manjinder-sandhu.png";
import drAshokSeth from "../Images/home/dr-ashok-seth.jpg";
import drSandeepVaishya from "../Images/home/dr-sandeep-vaishya.jpg";
import FortisContactModal from "../components/FortisContactModal";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ServiceCall from "../ServiceCall";
import { IoLanguageOutline } from "react-icons/io5";
import {
  Phone,
  Calendar,
  MessageCircle,
  Star,
  Award,
  Heart,
  Brain,
  Stethoscope,
} from "lucide-react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaTelegram,
  FaGooglePlay,
  FaApple,
} from "react-icons/fa";
import { Helmet } from "react-helmet";

const FortisDoctor = () => {
  const [fortisContactModalOpen, setFortisContactModalOpen] = useState(false);

  useEffect(() => {
    const addTranslateScript = () => {
      if (!document.getElementById("google-translate-script")) {
        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src =
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      }
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,fr,ar,ru,bn,hi,ro,es,pt",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    addTranslateScript();
  }, []);
  const [selectedCity, setSelectedCity] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState("");
  const [selectedRating, setSelectedRating] = useState("");
  const [selectedHospital, setSelectedHospital] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [search, setSearch] = useState("");
  const [limit] = useState(10);
  const mode = process.env.REACT_APP_MODE;
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState([]);
  const [pageMarking, setPageMarking] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [noDoctorsFound, setNoDoctorsFound] = useState(false);
  const [page, setPage] = useState(1);
  const handleSearchPagination = async (nextPage) => {
    setLoading(true);
    try {
      const somQuery = selectedFilter ? `&som=${selectedFilter}` : "";

      const response = await ServiceCall.gett(
        `/v2/patient/open/pagination/list/available/doctor/${mode}/${nextPage}/${limit}?name=${search}${somQuery}`
      );

      setPageMarking(response.data.page_marking);

      const newSearchResults = response.data.doctors;

      if (newSearchResults.length > 0) {
        setSearchResults((prevResults) => [
          ...prevResults,
          ...newSearchResults,
        ]);
        setHasMore(newSearchResults.length === limit);
      } else {
        setHasMore(false);
      }
      setLoading(false);
    } catch (err) {
      console.error("Search pagination error:", err);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!hasMore) return;

    if (search) {
      handleSearchPagination(page);
    } else {
      Handleapply(page);
    }
  }, [page]);
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100 &&
        hasMore &&
        !loading
      ) {
        setPage((prev) => prev + 1); // This triggers useEffect
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);
  const handleNewSearch = () => {
    setPage(1);
    setSearchResults([]);
    setHasMore(true);
    handleSearchPagination(1);
  };

  const Handleapply = async (currentPage) => {
    setLoading(true);

    try {
      // Hardcoding the hospital ID to always pass "28409fd2-b928-4924-bddf-d54cec1ec709"
      const body = {
        city: selectedCity,
        experince: parseInt(selectedExperience) || 0,
        rating: parseInt(selectedRating) || 0,
        hospital: "28409fd2-b928-4924-bddf-d54cec1ec709", // Pass the fixed hospital ID
      };

      const res = await ServiceCall.post(
        `/v2/patient/open/pagination/filter/list/available/doctor/${mode}/${currentPage}/${limit}?som=${selectedFilter}&name=${search}`,
        body
      );

      if (res) {
        setPageMarking(res.data.page_marking);
        const newDoctors = res.data.doctors;

        if (newDoctors.length > 0) {
          setDetails((prev) =>
            currentPage === 1 ? newDoctors : [...prev, ...newDoctors]
          );
          setNoDoctorsFound(false);
          setHasMore(newDoctors.length === limit);
        } else {
          if (currentPage === 1) {
            setDetails([]);
            setNoDoctorsFound(true);
          }
          setHasMore(false);
        }
      }
    } catch (err) {
      console.error(err);
      setNoDoctorsFound(true);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasMore || loading) return;

    if (search) {
      handleSearchPagination(page);
    } else {
      Handleapply(page);
    }
  }, [page]);
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100 &&
        hasMore &&
        !loading
      ) {
        setPage((prev) => prev + 1); // This triggers the effect
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hasMore, loading]);

  // Generate shimmer loading effect cards
  const renderShimmerCards = () => {
    return Array(6)
      .fill()
      .map((_, index) => (
        <div
          key={`shimmer-${index}`}
          className="bg-white rounded-xl shadow-lg overflow-hidden animate-pulse border border-gray-100"
        >
          <div className="h-60 bg-gray-200"></div>
          <div className="p-6">
            <div className="h-3 w-32 bg-gray-200 rounded mb-4"></div>
            <div className="h-2 w-24 bg-gray-200 rounded mb-3"></div>
            <div className="h-2 w-40 bg-gray-200 rounded mb-4"></div>
            <div className="pt-4 border-t border-gray-100 grid grid-cols-2 gap-3">
              <div className="h-8 bg-gray-200 rounded"></div>
              <div className="h-8 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      ));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Top Doctors - Fortis Memorial Hospital, India</title>
        <meta
          name="description"
          content="Our team of world-class doctors provides specialized care with the latest medical techniques and compassionate approach."
        />
        <meta
          name="keywords"
          content="Fortis Memorial Hospital, India, top doctors, medical care, specialized care, latest medical techniques, compassionate approach"
        />
        <meta name="author" content="Rx One Care Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@RxOneCare" />
        <meta name="twitter:creator" content="@RxOneCare" />
        <meta
          name="twitter:title"
          content="Top Doctors - Fortis Memorial Hospital, India"
        />
        <meta
          name="twitter:description"
          content="Our team of world-class doctors provides specialized care with the latest medical techniques and compassionate approach."
        />
        <meta
          name="og:title"
          content="Top Doctors - Fortis Memorial Hospital, India"
        />
        <meta
          name="og:description"
          content="Our team of world-class doctors provides specialized care with the latest medical techniques and compassionate approach."
        />

        <meta name="og:site_name" content="Rx One Care" />
        <meta name="og:type" content="website" />
      </Helmet>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center py-3">
          <div>
            <Link to="/hospitals/fortis" className="flex items-center">
              <img src={fortilogo} alt="Fortis Logo" className="h-10 md:h-12" />
            </Link>
          </div>

          <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
                        <div className="flex items-center mr-1 sm:mr-2 mt-1">
                          <span className="flex items-center text-gray-600 text-sm mr-2">
                            <IoLanguageOutline className="w-4 h-4 mr-1" />
                            <span className="hidden md:inline">Select Language:</span>
                          </span>
                          <div id="google_translate_element"></div>
                        </div>
          
                        <a
            href="tel:+911140847007"
                          className="hidden sm:flex items-center text-gray-700 hover:text-green-600 text-sm py-2 px-3 border border-gray-200 rounded-md transition-colors"
                        >
                          <Phone size={16} className="mr-2" />
                          <span>+91 011-408-47007</span>
                        </a>
          
                       <button
            className="bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-2 sm:px-4 rounded-md transition-colors flex items-center hide-on-mobile"
            onClick={() => setFortisContactModalOpen(true)}
          >
            <span>Callback Request</span>
          </button>
          <a
            href="tel:+911140847007"
            className="bg-green-600 hover:bg-green-700 text-white text-sm py-2 px-2 sm:px-4 rounded-md transition-colors flex items-center show-on-mobile"
            style={{ marginLeft: "10px", marginTop: "8px", fontWeight: 600, justifyContent: "center" }}
          >
            +91 011-408-47007
          </a>
                      </div>
        </div>
      </header>

      <div className="py-6 md:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Top Doctors{" "}
              <span className="text-green-600">
                - Fortis Memorial Hospital, India
              </span>
            </h1>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Our team of world-class doctors provides specialized care with the
              latest medical techniques and compassionate approach.
            </p>
          </div>

          {/* Search and filter section - REMOVED */}

          {noDoctorsFound && (
            <div className="text-center py-10">
              <div className="text-5xl mb-4">🔍</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                No Doctors Found
              </h3>
              <p className="text-gray-600">
                Please contact us for assistance finding the right specialist
                for your needs.
              </p>
              <button
                onClick={() => setFortisContactModalOpen(true)}
                className="mt-4 inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              >
                <MessageCircle size={16} className="mr-2" />
                Contact Us
              </button>
            </div>
          )}

          {/* Doctors grid with shimmer effect while loading */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {loading && details.length === 0
              ? renderShimmerCards()
              : details.map((doctor) => (
                  <div
                    key={doctor.doc_id}
                    className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border border-gray-100 h-full flex flex-col"
                  >
                    <div className="relative h-60 overflow-hidden">
                      <img
                        src={
                          doctor.doctor_profile_pic ||
                          "https://via.placeholder.com/300x400?text=Doctor"
                        }
                        alt={doctor.doctor_name}
                        className="h-full w-full object-contain"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://via.placeholder.com/300x400?text=Doctor";
                        }}
                      />
                      <div className="absolute top-3 right-3 bg-white rounded-full shadow-md p-1.5 flex items-center">
                        <Star
                          size={16}
                          className="text-amber-400 fill-amber-400"
                        />
                        <span className="text-gray-800 font-semibold ml-1 text-sm">
                          {doctor.google_rating || "4.5"}
                        </span>
                      </div>
                    </div>

                    <div className="p-6 flex-grow flex flex-col">
                      <div className="flex items-center mb-2">
                        <div className="h-3 w-3 rounded-full bg-green-500 mr-2"></div>
                        <span className="text-sm font-medium text-green-600">
                          Available for Consultation
                        </span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-900 mb-1">
                        {doctor.doctor_name}
                      </h3>

                      <div className="mb-2">
                        <span className="text-neutral-700 text-sm font-medium line-clamp-3">
                          {doctor.speciality || "Specialist"}
                        </span>
                      </div>

                      <div className="mb-auto text-gray-500 text-sm">
                        {doctor.experience > 0 && (
                          <p>{doctor.experience}+ years experience</p>
                        )}
                        <p className="line-clamp-2 mt-1">
                          Specializes in advanced medical procedures and patient
                          care
                        </p>
                      </div>

                      <div className="pt-4 border-t border-gray-100 grid grid-cols-2 gap-3 mt-4">
                        <a
                          href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                          className="flex items-center justify-center gap-1.5 bg-green-600 hover:bg-green-700 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaWhatsapp style={{ fontSize: 18 }} />
                          WhatsApp
                        </a>
                        <button
                          className="flex items-center justify-center gap-1.5 bg-gray-800 hover:bg-gray-900 text-white py-2 px-3 rounded-lg text-sm font-semibold transition-all"
                          onClick={() => setFortisContactModalOpen(true)}
                        >
                          <MessageCircle size={16} />
                          Contact Us
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
          </div>

          {/* Loading indicator for pagination */}
          {loading && page > 1 && (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600"></div>
            </div>
          )}

          {/* Load more button removed */}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Column 1: About */}
            <div>
              <h3 className="text-xl font-semibold mb-4 text-green-400">
                About RxOne
              </h3>
              <p className="text-gray-400 mb-4">
                Building Simple, Easy to Use and Effective Digital Health
                solutions for users, to solve care accessibility challenge in
                India and Worldwide.
              </p>

              <div className="flex space-x-4 mt-4">
                <a
                  href="https://www.facebook.com/profile.php?id=100089472039715"
                  className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center transition-all hover:bg-green-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF className="text-white text-sm" />
                </a>
                <a
                  href="https://twitter.com/RxOneCare"
                  className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center transition-all hover:bg-green-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaTwitter className="text-white text-sm" />
                </a>
                <a
                  href="https://www.linkedin.com/company/rx-one"
                  className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center transition-all hover:bg-green-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn className="text-white text-sm" />
                </a>
                <a
                  href="https://www.instagram.com/rxone_care?igsh=bzdsdTBzNjB3aTVr"
                  className="w-8 h-8 rounded-full bg-gray-800 flex items-center justify-center transition-all hover:bg-green-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram className="text-white text-sm" />
                </a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div>
              <h3 className="text-xl font-semibold mb-4 text-green-400">
                Quick Links
              </h3>
              <ul className="space-y-2">
                {[
                  "Hospitals",
                  "Doctors",
                  "Treatments",
                  "Blogs",
                  "About Us",
                  "Contact Us",
                ].map((link, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setFortisContactModalOpen(true);
                      }}
                      className="text-gray-400 hover:text-green-400 transition-colors flex items-center"
                    >
                      <span className="mr-2">›</span> {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Contact */}
            <div>
              <h3 className="text-xl font-semibold mb-4 text-green-400">
                Get in Touch
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <Phone className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                  <span className="text-gray-400">+91 770 393 4446</span>
                </li>
                <li className="flex items-start">
                  <FaWhatsapp className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                  <a
                    href="https://api.whatsapp.com/send?phone=+917703934446&text=Hello%20Team,%20Please%20call%20back.%20Looking%20for%20treatment%20in%20India."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-green-400"
                  >
                    WhatsApp Support
                  </a>
                </li>
                <li className="flex items-start">
                  <FaTelegram className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                  <a
                    href="https://t.me/RxOneSupport"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-green-400"
                  >
                    Telegram Support
                  </a>
                </li>
                <li className="flex items-start">
                  <MessageCircle className="h-5 w-5 text-green-400 mr-3 mt-0.5" />
                  <button
                    onClick={() => setFortisContactModalOpen(true)}
                    className="text-gray-400 hover:text-green-400 text-left"
                  >
                    Send a Message
                  </button>
                </li>
              </ul>
            </div>

            {/* Column 4: Mobile Apps */}
            <div>
              <h3 className="text-xl font-semibold mb-4 text-green-400">
                Mobile Apps
              </h3>
              <p className="text-gray-400 mb-4">
                Download the RxOne mobile app for seamless healthcare
                coordination on the go.
              </p>
              <div className="space-y-3">
                <a
                  href="https://play.google.com/store/apps/details?id=com.rxone"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-4 py-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-all"
                >
                  <FaGooglePlay className="h-5 w-5 text-white mr-3" />
                  <div>
                    <div className="text-xs text-gray-400">GET IT ON</div>
                    <div className="text-sm font-medium">Google Play</div>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/in/app/rxone-care-companion/id6479252685"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-4 py-2 bg-gray-800 rounded-lg hover:bg-gray-700 transition-all"
                >
                  <FaApple className="h-5 w-5 text-white mr-3" />
                  <div>
                    <div className="text-xs text-gray-400">Download on the</div>
                    <div className="text-sm font-medium">App Store</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-800 flex justify-center items-center">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Rx One Care Pvt. Ltd. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <FortisContactModal
        open={fortisContactModalOpen}
        onClose={() => setFortisContactModalOpen(false)}
      />
    </div>
  );
};

export default FortisDoctor;
